module.exports = __webpack_public_path__ + "img/symbol_5.850071b8.png";